import { render, staticRenderFns } from "./merchant_points_summary.vue?vue&type=template&id=759eb0e8&scoped=true"
import script from "./merchant_points_summary.vue?vue&type=script&lang=js"
export * from "./merchant_points_summary.vue?vue&type=script&lang=js"
import style0 from "./merchant_points_summary.vue?vue&type=style&index=0&id=759eb0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759eb0e8",
  null
  
)

export default component.exports